export default __webpack_public_path__ + "static/media/t1.120fec61.png";